<template>
  <div class="modal-card pop_min" id="draggable" style="overflow-y: hidden">
    <header class="modal-card-head pop-header">
      <p class="modal-card-title tit">
        {{ title }}
        <button
          class="btn-pop-close delete"
          aria-label="close"
          @click="$parent.close()"
        ></button>
      </p>
    </header>
    <section class="modal-card-body pop-content">
      <div class="inner-box">
        <div class="table-b" style="margin-bottom: 10px">
          <div>
            <div v-if="isNew" class="btn-wrap btn-type1 clearfix">
              <button class="btn-size btn-blue fl_right" @click="insert">
                <span class="btn-icon"><i class="fas fa-check"></i></span> 저장
              </button>
            </div>
            <div v-else class="btn-wrap btn-type1 clearfix">
              <button
                class="btn-size btn-gray fl_right"
                style="margin-left: 5px"
                @click="cancel"
              >
                <span class="btn-icon"><i class="fas fa-check"></i></span> 삭제
              </button>
              <button class="btn-size btn-blue fl_right" @click="update">
                <span class="btn-icon"><i class="fas fa-check"></i></span> 저장
              </button>
            </div>
          </div>
          <div class="inner-box" style="height: 210px">
            <div class="table-area">
              <div class="table-a">
                <table id="basic" class="table">
                  <colgroup>
                    <col width="15%" />
                    <col width="35%" />
                    <col width="15%" />
                    <col width="35%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th class="tp-a">전화번호</th>
                      <td>
                        <div class="td-s-thumb search-area" style="width: 200px">
                          <input
                            class="input"
                            type="text"
                            v-model="form.blackMobile"
                            maxlength="13"
                            placeholder="010-1234-5678"
                            :disabled="isNew ? false : true"
                          />
                        </div>
                      </td>
                      <th class="tp-a">사용여부</th>
                      <td>
                        <div
                          class="td-s-thumb search-area"
                          style="width: 100px; float: left"
                        >
                          <b-select v-model="form.useYn">
                            <option value="">==선택==</option>
                            <option value="Y">사용</option>
                            <option value="N">미사용</option>
                          </b-select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="tp-a">이름</th>
                      <td>
                        <div class="td-s-thumb search-area" style="width: 200px">
                          <input class="input" type="text" v-model="form.blackNm" />
                        </div>
                      </td>
                      <th class="tp-a">생년월일</th>
                      <td>
                        <div class="td-s-thumb search-area" style="width: 200px">
                          <input
                            class="input"
                            type="text"
                            v-model="form.blackBirth"
                            maxlength="10"
                            placeholder="1989-01-22"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="tp-a">방문회사</th>
                      <td>
                        <div class="td-s-thumb search-area" style="width: 200px">
                          <b-select class="select is-fullwidth" v-model="form.compCd">
                            <option value="100010">일진전기</option>
                            <option value="100002">일진홀딩스</option>
                            <option value="101301">일진다이아</option>
                            <option value="222300">알피니언메디칼</option>
                          </b-select>
                        </div>
                      </td>
                      <th class="tp-c">회사명</th>
                      <td>
                        <div class="td-s-thumb search-area" style="width: 200px">
                          <input class="input" type="text" v-model="form.blackCompNm" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="tp-c">내용</th>
                      <td colspan="3">
                        <div class="td-s-thumb search-area" style="width: auto">
                          <input class="input" type="text" v-model="form.remark" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Layout from "@/components/ModalSlot.vue";
import mixin from "@/mixin";
import mixinSlip from "@/mixin/slip";
import _ from "lodash";

export default {
  name: "BlackDetailMg",
  props: {
    compCd: {
      type: String,
      required: false,
    },
    mobileNo: {
      type: String,
      required: false,
    },
    isNew: {
      type: Boolean,
      require: true,
    },
  },
  mixins: [mixin, mixinSlip],
  components: { Layout },
  data() {
    return {
      title: "BlackList 관리",
      form: {
        blackMobile: "",
        blackNm: "",
        blackBirth: "",
        blackCompNm: "",
        useYn: "Y",
        remark: "",
        compCd: "100010",
      },
      returnObject: {},
    };
  },
  methods: {
    getBlackInfo(visitCompCd, blackMobile) {
      this.$http
        .get(`/api/visit/black/info`, {
          params: { compCd: visitCompCd, blackMobile: blackMobile },
        })
        .then((response) => {
          this.form = response.data;
        });
    },
    insert() {
      if (!this.validation()) return;
      this.$swal({
        type: "warning",
        text: `블랙리스트 정보를 저장합니다. 계속 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: "예",
        cancelButtonText: "아니오",
      }).then((result) => {
        if (result.value) {
          const param = JSON.parse(JSON.stringify(this.form));
          const stripFields = ["blackMobile", "blackBirth"];
          _.forEach(stripFields, (name) => (param[name] = this.toPure(param[name])));

          this.$http
            .post(`/api/visit/black/insert`, param)
            .then((response) => {
              this.$swal({ type: "info", text: "저장되었습니다." });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.$parent.close();
              this.$parent.$parent.goSearch();
            });
        }
      });
    },
    update() {
      if (!this.validation()) return;
      this.$swal({
        type: "warning",
        text: `블랙리스트 정보를 수정합니다. 계속 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: "예",
        cancelButtonText: "아니오",
      }).then((result) => {
        if (result.value) {
          const param = JSON.parse(JSON.stringify(this.form));
          const stripFields = ["blackMobile", "blackBirth"];
          _.forEach(stripFields, (name) => (param[name] = this.toPure(param[name])));

          this.$http
            .post(`/api/visit/black/update`, param)
            .then((response) => {
              this.$swal({ type: "info", text: "저장되었습니다." });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.$parent.close();
              this.$parent.$parent.goSearch();
            });
        }
      });
    },
    cancel() {
      this.$swal({
        type: "warning",
        text: `블랙리스트 정보를 삭제합니다. 계속 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: "예",
        cancelButtonText: "아니오",
      }).then((result) => {
        if (result.value) {
          const param = JSON.parse(JSON.stringify(this.form));
          const stripFields = ["blackMobile", "blackBirth"];
          _.forEach(stripFields, (name) => (param[name] = this.toPure(param[name])));

          this.$http
            .post(`/api/visit/black/mgDelete`, param)
            .then((response) => {
              this.$swal({ type: "info", text: "삭제되었습니다." });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.$parent.close();
              this.$parent.$parent.goSearch();
            });
        }
      });
    },
    validation() {
      const formInfo = JSON.parse(JSON.stringify(this.form));

      if (!formInfo.useYn) {
        this.$swal({ type: "warning", text: "사용여부를 선택해 주세요." });
        return false;
      }

      return true;
    },
    doReturnObject(rId) {
      this.returnObject.name = "";
      this.$parent.$emit("receive", this.returnObject);
      this.closeModal();
    },
    closeModal() {
      this.$parent.close();
    },
  },
  mounted() {
    if (!this.isNew) {
      this.getBlackInfo(
        this.compCd,
        this.mobileNo.replace(/-/g, "").replace(/[^0-9]/g, "")
      );
    }
  },
  watch: {
    "form.blackMobile": {
      deep: true,
      handler(value) {
        let val = value.replace(/-/g, "").replace(/[^0-9]/g, "");
        let len = val.length;
        if (len == 11) {
          this.form.blackMobile = val.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        } else if (len == 8) {
          this.form.blackMobile = val.replace(/(\d{4})(\d{4})/, "$1-$2");
        } else if (len == 9) {
          this.form.blackMobile = val.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
        } else {
          if (val.indexOf("02") == 0) {
            this.form.blackMobile = val.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
          } else {
            this.form.blackMobile = val.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
          }
        }
      },
    },
    "form.blackBirth": {
      deep: true,
      handler(value) {
        let val = value.replace(/-/g, "").replace(/[^0-9]/g, "");
        let len = val.length;
        this.form.blackBirth = val.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
      },
    },
  },
};
</script>

<style scoped>
div#gridbox {
  width: 100%;
  height: 100%;
  min-height: 300px;
}

.desc-content:after {
  clear: both;
  content: "";
  display: block;
}

.btn-wrap {
  margin-bottom: 20px;
}

.desc-content {
  border: 2px solid #9db6c9;
  background: #f9fafc;
  margin: 0 0 20px 0;
  border-radius: 4px;
  padding: 15px 2%;
  clear: both;
}

.desc-content .item {
  float: left;
}

.desc-content .item .desc-item {
  position: relative;
  padding-left: 82px;
  margin-bottom: 8px;
}

.desc-content .item .desc-item:last-child {
  margin-bottom: 0;
  height: 25px;
}

.desc-content .item .desc-item .tit {
  position: absolute;
  left: 0;
}

.desc-content .item .desc-item .label-tit {
  font-family: "NotoM";
  color: #222;
  font-size: 15px;
}

.desc-content .item.desc-left .desc-item {
  padding-left: 90px;
}

.desc-content .item.desc-left .desc-item .desc:after {
  clear: both;
  content: "";
  display: block;
}

.desc-content .item.desc-left .desc-item .desc .datepicker {
  float: left;
}

.desc-content .item.desc-left .desc-item .desc span.wave {
  float: left;
  padding: 0 6px;
}

.desc-content .item.desc-left .desc-item .td-s-thumb.search-area:after {
  clear: both;
  content: "";
  display: block;
}

.desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
  float: left;
}

.desc-content .item.desc-left .desc-item .desc.select select {
  width: 70%;
}

.desc-content .item.desc-left {
  width: 35%;
  padding-right: 40px;
}

.desc-content .item.desc-center {
  width: 35%;
  padding-right: 40px;
}

.desc-content .item.desc-right {
  width: 30%;
}

.search-area input {
  position: relative;
}

.search-area .icon {
  position: absolute;
  right: 8px;
  top: 1px;
  z-index: 100;
  cursor: pointer;
  font-size: 16px;
  color: #555;
}

.search-border .td-s-thumb {
  position: relative;
  display: inline-block;
}

.search-border .td-s-thumb.search-area > input,
.search-border
  .td-s-thumb.search-area
  > .ip-box
  .search-border
  .td-s-thumb.search-area
  > button {
  float: left;
}

.search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
  width: 60%;
  margin-left: 6px;
}

.remove_text {
  margin-left: 0;
}

.contents div.gridbox_material.gridbox .xhdr {
  border-bottom: 1px solid #dfdfdf;
}

@media (max-width: 1580px) {
  .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
    width: 50%;
  }
}

.modal-card {
  width: auto;
}

.tp-a {
  padding-left: 23px;
}

.tp-c {
  padding-left: 23px;
}

.table-area .table-a table th.tp-a:before {
  content: "*";
  color: #f04f2f;
  position: absolute;
  left: 11px;
  top: 16px;
}
</style>
